// src/app/app.module.ts
import { CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NgModule } from '@angular/core'; // Removed importProvidersFrom as it's not used here
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule, DatePipe } from '@angular/common';

// Firebase imports
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { provideFirestore, getFirestore } from '@angular/fire/firestore';
import { environment } from '../environments/environment';
import { provideFunctions, getFunctions } from '@angular/fire/functions'; // <-- AÑADE ESTA LÍNEA

// Component imports
import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { registerLocaleData } from '@angular/common'; // Import registerLocaleData
import localeEsDo from '@angular/common/locales/es-DO';
import { HistoryComponent } from './history/history.component';
import { HomeComponent } from './home/home.component';
import { ReadyComponent } from './ready/ready.component';
import { ClientsComponent } from './clients/clients.component'; // Import Spanish locale data
import { HttpClientModule } from '@angular/common/http';
import { AnalyticsComponent } from './analytics/analytics.component';
import { InventoryComponent } from './inventory/inventory.component';
import { AppointmentsComponent } from './appointments/appointments.component';
import { TrackingComponent } from './tracking/tracking.component';
import { ClientPortalComponent } from './client-portal/client-portal.component';
import { ComissionsComponent } from './comissions/comissions.component';
import { InspectionComponent } from './inspection/inspection.component';
import { InspeccionesViewComponent } from './inspecciones-view/inspecciones-view.component';
// En la parte superior de src/app/app.module.ts
registerLocaleData(localeEsDo, 'es-DO'); // Register Spanish locale



@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
   DashboardComponent,
   HistoryComponent,
   HomeComponent,
   ReadyComponent,
   ClientsComponent,
   AnalyticsComponent,
   InventoryComponent,
   AppointmentsComponent,
   TrackingComponent,
   ClientPortalComponent,
   ComissionsComponent,
   InspectionComponent,
   InspeccionesViewComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule
    // Firebase providers are now in the 'providers' array below
  ],
  providers: [
    // Add Firebase providers here
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAuth(() => getAuth()),
    provideFirestore(() => getFirestore()),
    provideFirestore(() => getFirestore()),
    provideFunctions(() => getFunctions()), // <-- AÑADE ESTA LÍNEA
     { provide: LOCALE_ID, useValue: 'es-DO' } ,
      DatePipe 
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA] // <-- Agregar esta línea aquí

})
export class AppModule { }